// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__+SIaL","search":"SearchBar_search__n1hCQ"};